import Icon from '../components/Icon.vue'

Icon.register({
  dove: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M288 167.2c-50.8-10.5-96.6-36.8-130.8-75.1 11.2-32.4 27.8-61.6 48.9-86.5 8.8-10.5 25.7-5.2 27.8 8.3 7 45.9 25.9 88.9 54.1 125.2v28.1zM400 64h112l-32 64v160.1c0 88.4-71.6 159.9-160 159.9h-76.9l-65.2 56.1c-6.1 5.3-14.1 8.2-22.1 7.9-92.8-3.8-135.8-49.4-153.2-76.3-6-9.3-1.2-21.7 9.5-24.4l143.9-36c-12.8-9.6-25.7-20.1-38.9-32.8-51-49-85.1-115.1-85.1-185.9 0-41.4 9.4-80.6 26-115.7 5.8-12.3 23.5-11.6 29 0.9 40 91.2 128.6 155.5 233 161.7v-59.4c0-44.2 35.8-80.1 80-80.1zM400 160.1c8.8 0 16-7.2 16-16 0-8.8-7.2-16-16-16s-16 7.2-16 16c0 8.8 7.2 16 16 16z'
      }
    ]
  }
})
